import CreateSourceModal from './CreateSourceModal';

import './CreateSourceModal.scss';

export default CreateSourceModal;
